// Gestor de notificaciones global
class NotificationManager {
  constructor() {
    this.instance = null;
  }

  setInstance(instance) {
    this.instance = instance;
  }

  getInstance() {
    return this.instance;
  }

  // Métodos genéricos para cualquier tipo de notificación
  showSuccess(title, message, action = null) {
    if (this.instance) {
      return this.instance.showSuccess(title, message, action);
    }
    console.warn("NotificationManager: No instance available");
    return null;
  }

  showError(title, message, action = null) {
    if (this.instance) {
      return this.instance.showError(title, message, action);
    }
    console.warn("NotificationManager: No instance available");
    return null;
  }

  showWarning(title, message, action = null) {
    if (this.instance) {
      return this.instance.showWarning(title, message, action);
    }
    console.warn("NotificationManager: No instance available");
    return null;
  }

  showInfo(title, message, action = null) {
    if (this.instance) {
      return this.instance.showInfo(title, message, action);
    }
    console.warn("NotificationManager: No instance available");
    return null;
  }

  showLoading(title, message, persistent = false, data = null) {
    if (this.instance) {
      return this.instance.showLoading(title, message, persistent, data);
    }
    console.warn("NotificationManager: No instance available");
    return null;
  }

  showCustom(type, title, message, options = {}) {
    if (this.instance) {
      return this.instance.showCustom(type, title, message, options);
    }
    console.warn("NotificationManager: No instance available");
    return null;
  }

  addNotification(notification) {
    if (this.instance) {
      return this.instance.addNotification(notification);
    }
    console.warn("NotificationManager: No instance available");
    return null;
  }

  removeNotification(id) {
    if (this.instance) {
      this.instance.removeNotification(id);
    } else {
      console.warn("NotificationManager: No instance available");
    }
  }

  /**
   * Removes notifications matching predicate. Returns removed ids.
   * @param {(n: object) => boolean} predicate
   */
  removeNotificationsWhere(predicate) {
    if (this.instance && typeof this.instance.removeNotificationsWhere === 'function') {
      return this.instance.removeNotificationsWhere(predicate);
    }
    return [];
  }

  clearAllNotifications() {
    if (this.instance) {
      this.instance.clearAllNotifications();
    } else {
      console.warn("NotificationManager: No instance available");
    }
  }

  getNotificationsByType(type) {
    if (this.instance) {
      return this.instance.getNotificationsByType(type);
    }
    return [];
  }

  getNotifications() {
    if (this.instance && Array.isArray(this.instance.notifications)) {
      return this.instance.notifications.slice();
    }
    return [];
  }

  // Métodos para actualizar notificaciones
  updateNotification(id, updates) {
    if (this.instance) {
      this.instance.updateNotification(id, updates);
    } else {
      console.warn("NotificationManager: No instance available");
    }
  }

  updateProgress(id, progress) {
    if (this.instance) {
      this.instance.updateProgress(id, progress);
    } else {
      console.warn("NotificationManager: No instance available");
    }
  }

  updateMessage(id, message) {
    if (this.instance) {
      this.instance.updateMessage(id, message);
    } else {
      console.warn("NotificationManager: No instance available");
    }
  }

  updateTitle(id, title) {
    if (this.instance) {
      this.instance.updateTitle(id, title);
    } else {
      console.warn("NotificationManager: No instance available");
    }
  }

  convertNotification(id, newType, newTitle, newMessage, options = {}) {
    if (this.instance) {
      this.instance.convertNotification(
        id,
        newType,
        newTitle,
        newMessage,
        options
      );
    } else {
      console.warn("NotificationManager: No instance available");
    }
  }
}

// Exportar una instancia única
export const notificationManager = new NotificationManager();

// Mixin para componentes Vue
export const notificationMixin = {
  methods: {
    // Métodos genéricos
    $showNotification(notification) {
      return notificationManager.addNotification(notification);
    },

    $showSuccess(title, message, action = null) {
      return notificationManager.showSuccess(title, message, action);
    },

    $showError(title, message, action = null) {
      return notificationManager.showError(title, message, action);
    },

    $showWarning(title, message, action = null) {
      return notificationManager.showWarning(title, message, action);
    },

    $showInfo(title, message, action = null) {
      return notificationManager.showInfo(title, message, action);
    },

    $showLoading(title, message, persistent = false, data = null) {
      return notificationManager.showLoading(title, message, persistent, data);
    },

    $showCustom(type, title, message, options = {}) {
      return notificationManager.showCustom(type, title, message, options);
    },

    // Métodos de gestión
    $removeNotification(id) {
      notificationManager.removeNotification(id);
    },

    $clearAllNotifications() {
      notificationManager.clearAllNotifications();
    },

    $getNotificationsByType(type) {
      return notificationManager.getNotificationsByType(type);
    },

    // Métodos para actualizar notificaciones
    $updateNotification(id, updates) {
      notificationManager.updateNotification(id, updates);
    },

    $updateProgress(id, progress) {
      notificationManager.updateProgress(id, progress);
    },

    $updateMessage(id, message) {
      notificationManager.updateMessage(id, message);
    },

    $updateTitle(id, title) {
      notificationManager.updateTitle(id, title);
    },

    $convertNotification(id, newType, newTitle, newMessage, options = {}) {
      notificationManager.convertNotification(
        id,
        newType,
        newTitle,
        newMessage,
        options
      );
    },
  },
};
